<app-document-filters-drawer [(filters)]="documentService.filters" #documentFiltersDrawer>

  <div class="fx-column">
    <div class="fx-row align-items-center justify-content-between">
      <app-back [action]="back.bind(this)"></app-back>
      <div class="fx-row align-items-center justify-content-end">
        <div class="chip fx-row align-items-center justify-content-start clickable" [class.main]="hasFilters"
          [class.light]="!hasFilters" (click)="toggleDrawer();"
          [matTooltip]="'DOCUMENT.HAS_NO_APPLIED_FILTERS' | translate" [matTooltipClass]="{'uzai-tooltip':true}"
          [matTooltipDisabled]="hasFilters">
          <mat-icon class="mr-5">{{hasFilters ? 'filter_list' : 'filter_list_off'}}</mat-icon>
          <span *ngIf="hasFilters">{{"DOCUMENT.HAS_APPLIED_FILTERS" | translate}} ({{filtersCount}})</span>
        </div>
        <ng-template #approvalMenu>
          <mat-card class="menu-container p-8 elevation" cdkMenu
            *ngIf="document && document.approval && document.approval.status !== 'pending' && document.approval.user">
            <span class="small bold">{{(approval === 'approved' ? "DOCUMENT.APPROVED_BY" : "DOCUMENT.REJECTED_BY")
              |translate}}</span>
            <div class="fx-row justify-content-start align-items-center">
              <app-avatar [user]="document.approval.user" [size]="24"></app-avatar>
              <div class="fx-column align-items-start justify-content-start ml-10">
                <span class="small">{{document.approval.user.firstName}} {{document.approval.user.lastName}}</span>
                <span class="small light"
                  *ngIf="document.approval.date">{{formatDatetimeMinute(document.approval.date)}}</span>
              </div>
            </div>
          </mat-card>
          <mat-card class="menu-container p-8 elevation" cdkMenu
            *ngIf="document && (!document.approval || document.approval.status === 'pending');">
            <span class="small">{{"DOCUMENT.APPROVAL_PENDING_HINT" | translate}}</span>
          </mat-card>
        </ng-template>
        <div class="chip fx-row align-items-center justify-content-start clickable ml-20"
          [class.orange]="approval === 'pending'" [class.green]="approval === 'approved'"
          [class.red]="approval === 'rejected'" [cdkMenuTriggerFor]="approvalMenu">
          <mat-icon class="mr-5" [class.orange]="approval === 'pending'" [class.green]="approval === 'approved'"
            [class.red]="approval === 'rejected'" fontSet="material-icons-outlined">{{(approval === 'approved' ?
            "check_circle" : (approval === 'rejected' ? "not_interested" :
            "help_outline")) | translate}}</mat-icon>
          {{(approval === 'approved' ? "DOCUMENT.APPROVAL_APPROVED" : (approval === 'rejected' ?
          "DOCUMENT.APPROVAL_REJECTED" :
          "DOCUMENT.APPROVAL_PENDING")) | translate}}
        </div>
        <button class="main-button ml-20" (click)="openEditMetadata()"
          [disabled]="!document || document.status !== 'PROCESSED' || document.nonUse"
          [class.disabled]="document?.status !== 'PROCESSED' || document?.nonUse"
          *ngIf="![DocumentEditMode.EDIT_REDACTS,DocumentEditMode.EDIT_METADATA].includes(mode)">
          {{'DOCUMENT.EDIT_METADATA' | translate}}
        </button>
        <button [cdkMenuTriggerFor]="menu" class="button ml-20">
          <div class="fx-row align-items-center justify-content-between fx-flex-100">
            <span class="dark fx-flex">{{'ACTIONS.ACTIONS' | translate}}</span>
            <mat-icon class="dark ml-5" fontSet="material-icons-outlined">arrow_drop_down</mat-icon>
          </div>
        </button>
      </div>
      <ng-template #menu>
        <mat-card class="menu-container p-0 elevation" cdkMenu>
          <div class="fx-column">
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="canDisplayOrDownload('download') ? download('evidence') : null" cdkMenuItem>
              <mat-icon class="dark mr-5" [class.light]="!canDisplayOrDownload('download')"
                fontSet="material-icons-outlined">file_download</mat-icon>
              <span class="text" [class.light]="!canDisplayOrDownload('download')">{{'DOCUMENT.DOWNLOAD' |
                translate}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="canDisplayOrDownload('download') ? download('originalWithDocumentData') : null" cdkMenuItem >
              <mat-icon class="dark mr-5" [class.light]="!canDisplayOrDownload('download')"
                fontSet="material-icons-outlined">file_download</mat-icon>
              <span class="text" [class.light]="!canDisplayOrDownload('download')">{{
                  'DOCUMENT.DOWNLOAD_ORIGINAL_AND_DOCUMENT_DATA' | translate
                }}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="canDisplayOrDownload('download') ? download('original') : null" cdkMenuItem roleBasedElement
              [roles]="['SUPERADMIN']">
              <mat-icon class="dark mr-5" [class.light]="!canDisplayOrDownload('download')"
                fontSet="material-icons-outlined">file_download</mat-icon>
              <span class="text" [class.light]="!canDisplayOrDownload('download')">{{'DOCUMENT.DOWNLOAD_ORIGINAL' |
                translate}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="(!document || document.status !== 'PROCESSED' || document.nonUse) ? null : openEditRedacts()"
              cdkMenuItem roleBasedElement>
              <mat-icon class="dark mr-5"
                [class.light]="!document || document.status !== 'PROCESSED' || document.nonUse"
                fontSet="material-icons-outlined">content_cut</mat-icon>
              <span class="text"
                [class.light]="!document || document.status !== 'PROCESSED' || document.nonUse">{{'DOCUMENT.EDIT_REDACTS'
                | translate}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="toggleConfidentiality()" cdkMenuItem roleBasedElement [roles]="['SUPERADMIN','ADMIN','MANAGER']">
              <mat-icon class="dark mr-5" fontSet="material-icons-outlined">{{document?.confidential ? 'lock_open' :
                'lock'}}</mat-icon>
              <span class="text">{{(document?.confidential ? 'DOCUMENT.MAKE_UNCONFIDENTIAL' :
                'DOCUMENT.MAKE_CONFIDENTIAL') |
                translate}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item" [class.clickable]="!document?.nonUse"
              [class.actionable]="!document?.nonUse" (click)="document?.nonUse ? null : reanalyze()" cdkMenuItem
              aclBasedElement resource="DOCUMENT" [scopes]="['U']">
              <mat-icon class="dark mr-5" fontSet="material-icons-outlined"
                [class.light]="document?.nonUse">sync</mat-icon>
              <span class="text" [class.light]="document?.nonUse">{{'ACTIONS.REANALYZE' | translate}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
              (click)="delete()" cdkMenuItem aclBasedElement resource="DOCUMENT" [scopes]="['D']">
              <mat-icon class="red mr-5" fontSet="material-icons-outlined">delete</mat-icon>
              <span class="text">{{'ACTIONS.DELETE' | translate}}</span>
            </div>
          </div>
        </mat-card>
      </ng-template>
    </div>
  </div>
  <mat-card class="p-0 mt-20" *ngIf="document">
    <div class="fx-row align-items-start justify-content-start">
      <div class="document-viewer fx-flex-60" (wheel)="mouseWheelToZoom($event)">
        <div class="document-overlay" *ngIf="locked && document && done">
          <mat-card class="overlay-card elevation">
            <div class="fx-column align-items-center justify-content-center">
              <div class="lock-container">
                <mat-icon class="main" fontSet="material-icons-outlined">lock</mat-icon>
              </div>
              <span class="title">
                {{'DOCUMENT.PROTECTED' | translate}}
              </span>
              <span class="text text-center">
                {{'DOCUMENT.PROTECTED_NEED_OTP' | translate}}
              </span>
              <div class="fx-row align-items-center justify-content-center mt-10 fx-flex">
                <button class="main-button fx-flex" (click)="authenticate()">
                  {{'ACTIONS.AUTHENTICATE' | translate}}
                </button>
              </div>
            </div>
          </mat-card>
        </div>
        <div *ngIf="loading" class="document-loader">
          <mat-progress-spinner class="white-spinner" mode="indeterminate" diameter="45">
          </mat-progress-spinner>
        </div>
        <div *ngIf="!loading && src" class="pdf-viewer" #pdfViewer>
          <div class="canvas-container" #canvasContainer>
          </div>
          <div class="annotation-canvas-container" [class.hidden]="currentRenderTask" #annotationCanvasContainer>
          </div>
          <div class="drawing-canvas-container" #drawingCanvasContainer>
          </div>
          <mat-card class="drawing-help-popup" *ngIf="isDraw && helpPopup" [@fadeInOut]>
            <div class="fx-column">
              <div class="fx-row align-items-center justify-content-between">
                <span class="text bold main">
                  {{'DOCUMENT.POPUP_ANNOTATE_TITLE' | translate}}
                </span>
                <mat-icon class="light ml-20 clickable" (click)='closeDrawingHelpPopup()'>close</mat-icon>
              </div>
              <span class="text dark">{{'DOCUMENT.POPUP_ANNOTATE_MESSAGE'| translate}}</span>
            </div>
          </mat-card>
          <div class="pdf-actions border-right border-box border-top">
            <div class="fx-row align-items-center justify-content-start">
              <div class="fx-row align-items-center justify-content-start">
                <span class="small mr-10">Page {{$currentPage()}} {{('UTILS.OF' | translate).toLowerCase()}} {{pdf ?
                  pdf.numPages : 1}}</span>
                <mat-icon class="light ml-10 clickable" [class.lighter]="isPreviousPageDisabled()"
                  [class.disabled]="isPreviousPageDisabled()" (click)="previousPage()" fontSet="material-icons-outlined"
                  *ngIf="document?.type === 'application/pdf'">navigate_before</mat-icon>
                <mat-icon class="light ml-10 clickable" [class.lighter]="isNextPageDisabled()"
                  [class.disabled]="isNextPageDisabled()" (click)="nextPage()" fontSet="material-icons-outlined"
                  *ngIf="document?.type === 'application/pdf'">navigate_next</mat-icon>
              </div>
              <mat-slide-toggle class="ml-20" color="main" [checked]="displayMode === 'evidence'"
                [disabled]="!document || document.status !== 'PROCESSED' || document.nonUse"
                (change)="onDisplayModeChange($event)">
                {{"DOCUMENT.EVIDENCE_VERSION"|translate}}
              </mat-slide-toggle>
            </div>


            <div class="fx-row align-items-center justify-content-start">
              <mat-icon class="light ml-10 clickable" (click)="!canFitWidth ? null : fitWidth()"
                [class.lighter]="!canFitWidth" [class.disabled]="!canFitWidth" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'ACTIONS.FIT_WIDTH' | translate" [matTooltipDisabled]="!canFitWidth">
                width_full
              </mat-icon>
              <mat-icon class="light ml-10 clickable" (click)="!canFitHeight ? null : fitHeight()"
                [class.lighter]="!canFitHeight" [class.disabled]="!canFitHeight"
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'ACTIONS.FIT_HEIGHT' | translate"
                [matTooltipDisabled]="!canFitHeight">
                height
              </mat-icon>
              <mat-icon class="light ml-10 clickable" (click)="resetDisplay()" [class.lighter]="zoom === 1"
                [class.disabled]="zoom === 1" fontSet="material-icons-outlined"
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'ACTIONS.RESET_LAYOUT' | translate"
                [matTooltipDisabled]="zoom === 1">fullscreen_exit</mat-icon>
              <mat-icon class="light ml-10 clickable" (click)="zoomInClick()" fontSet="material-icons-outlined"
                [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'ACTIONS.ZOOM_IN' | translate">zoom_in</mat-icon>
              <mat-icon class="light ml-10 clickable" [class.lighter]="zoom === 1" [class.disabled]="zoom === 1"
                (click)="zoom === 1 ? null :zoomOutClick()" fontSet="material-icons-outlined"
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'ACTIONS.ZOOM_OUT' | translate"
                [matTooltipDisabled]="zoom === 1">zoom_out</mat-icon>
            </div>
          </div>
        </div>
        <!-- <img [src]="src" *ngIf="!loading && src && document?.type !== 'application/pdf'" class="image-viewer" /> -->
        <div *ngIf="!loading && !src" class="placeholder-viewer"></div>
      </div>
      <div class="document-metadata fx-flex-40 fx-column" [ngSwitch]="mode">
        <app-edit-document-metadata *ngSwitchCase="DocumentEditMode.EDIT_METADATA" [document]="document"
          [evidences]="filteredEvidences" [metadata]="filteredMetadata" [productsServices]="document.productsServices"
          [caseContext]="caseContext" [trademarkTerritories]="trademarkTerritories"
          (close)="closeEditMetadata()" (mouseenter)="showPreciseEvidence($event)"
          (mouseleave)="hidePreciseEvidence($event)" (add)="addMetadata($event)" (update)="updateMetadata($event)"
          (delete)="deleteMetadata($event)" (toggleDraw)="toggleDraw()" [drawing]="drawing" [isDraw]="isDraw"
          (confirmAnnotation)="confirmAnnotation($event)" (cancelAnnotation)="cancelAnnotation()"
          (confirmWithoutZone)="confirmWithoutZone($event)"
          (approveOrReject)="onApproveOrReject($event)" (hoverEvidence)="onHoverEvidenceOrRedact($event)"
          (evidenceSelectionChange)="onEvidenceSelectionChange($event)" [deleting]="deletingMetadata"
          #editDocumentMetadata></app-edit-document-metadata>
        <app-edit-document-redacts *ngSwitchCase="DocumentEditMode.EDIT_REDACTS" [document]="document"
          [redacts]="redacts" (onToggleShowEvidencesWithRedacts)="onToggleShowEvidencesWithRedacts($event)"
          (close)="closeEditMetadata()" (mouseenter)="showPreciseRedact($event.redactId)"
          (mouseleave)="hidePreciseRedact($event.redactId)" (delete)="deleteRedact($event)" (toggleDraw)="toggleDraw()"
          [drawing]="drawing" [isDraw]="isDraw" (confirmRedact)="confirmRedact($event)"
          (cancelAnnotation)="cancelAnnotation()" (hoverRedactInfo)="onHoverEvidenceOrRedact($event)"
          #editDocumentRedacts [currentHighlight]="currentHighlight"></app-edit-document-redacts>
        <div *ngSwitchCase="DocumentEditMode.CONSULT">
          <div class="fx-row align-items-center justify-content-start p-16">
            <img [src]="documentIcon()" [height]="45" />
            <div class="fx-row fx-wrap ml-16 fx-flex">
              <div class="fx-flex-100" style="word-break:break-all;overflow:hidden;">
                <span class="title bold" style="min-width:0;">
                  {{document.name}}
                </span>
              </div>
              <div class="fx-flex-100">
                <span class="small light"
                  *ngIf="document?.type === 'application/pdf' && document?.pages">{{document.pages}}
                  {{((document.pages &&
                  document.pages > 1 ? 'DOCUMENT.PAGES' : 'DOCUMENT.PAGE') | translate).toLowerCase()}} |
                  {{formatSize()}}</span>
                <span class="small light"
                  *ngIf="document?.type !== 'application/pdf' || !document?.pages">{{formatSize()}}</span>
              </div>
              <div class="fx-row align-items-center justify-content-start fx-flex-100" *ngIf="document.confidential">
                <mat-icon class="mr-5 main" fontSet="material-icons-outlined" [matTooltipClass]="{'uzai-tooltip':true}"
                  [matTooltip]="'CONFIDENTIALITY.CONFIDENTIAL' | translate" inset inline>lock</mat-icon>
                <span class="text main">{{'CONFIDENTIALITY.CONFIDENTIAL' | translate}}</span>
              </div>
              <div class="fx-row align-items-center justify-content-start fx-flex-100" *ngIf="document.nonUse">
                <mat-icon class="mr-5 main" fontSet="material-icons-outlined" [matTooltipClass]="{'uzai-tooltip':true}"
                  [matTooltip]="'DOCUMENT.NON_USE' | translate" inset inline>assignment_late</mat-icon>
                <span class="text main">{{'DOCUMENT.NON_USE' | translate}}</span>
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <mat-tab-group mat-stretch-tabs="true" (selectedTabChange)="onTabChange($event)">
            <mat-tab>
              <ng-template mat-tab-label class="text">
                {{'DOCUMENT.PROOFS_TAB' | translate}}
              </ng-template>
              <div class="fx-row fx-wrap align-items-stretch justify-content-start">
                <div class="fx-flex-50 fx-column fx-wrap align-items-start justify-content-start p-16 border-box"
                  (mouseenter)="shouldShowOrderPossibility() ? showTypeEvidences('STORE_ORDER_POSSIBILITY') : null"
                  (mouseleave)="shouldShowOrderPossibility() ? hideTypeEvidences('STORE_ORDER_POSSIBILITY') : null">
                  <app-document-class class="w-100" [documentClass]="document.class" [metadata]="metadata"
                    [showEye]="shouldShowOrderPossibility()"></app-document-class>
                  <app-document-order-possibility class="w-100" [possibility]="document.orderPossibility"
                    [metadata]="metadata" *ngIf="shouldShowOrderPossibility()"></app-document-order-possibility>
                </div>
                <div
                  class="fx-flex-50 fx-row fx-wrap align-items-start justify-content-start p-16 border-box border-left"
                  (mouseenter)="showTypeEvidences('LANG')" (mouseleave)="hideTypeEvidences('LANG')">
                  <app-document-langs class="w-100" [shown]="evidenceTypes['LANG'] && !document.nonUse"
                    [langs]="document.langs" [metadata]="metadata"></app-document-langs>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-row fx-wrap align-items-stretch justify-content-start">
                <div class="fx-flex-100 fx-column  align-items-start justify-content-start p-16 border-box"
                  (mouseenter)="showTypeEvidences('PRODUCT_SERVICE'); showTypeEvidences('TRADEMARK'); showTypeEvidences('NICE_CLASS')"
                  (mouseleave)="hideTypeEvidences('PRODUCT_SERVICE'); hideTypeEvidences('TRADEMARK'); hideTypeEvidences('NICE_CLASS')">
                  <app-document-products-services class="w-100"
                    [shown]="evidenceTypes['PRODUCT_SERVICE'] && !document.nonUse" [documentId]="document._id"
                    [trademarks]="document.trademarks" [productsServices]="document.productsServices"
                    [metadata]="metadata" [trademarkFilter]="documentService.filters.trademark"
                    [niceClassFilter]="documentService.filters.classNumber"
                    [productServicesFilter]="documentService.filters.productsServices"></app-document-products-services>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-row fx-wrap align-items-stretch justify-content-start">
                <div class="fx-flex-100 p-16 fx-column align-items-start justify-content-start border-box"
                  (mouseenter)="showTypeEvidences('NICE_CLASS')" (mouseleave)="hideTypeEvidences('NICE_CLASS')">
                  <app-document-nice-classes class="w-100" [shown]="evidenceTypes['NICE_CLASS'] && !document.nonUse"
                    [niceClassification]="document.niceClassification" [productsServices]="document.productsServices"
                    [metadata]="metadata" [filter]="documentService.filters.classNumber"></app-document-nice-classes>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-row fx-wrap align-items-stretch justify-content-start"
                (mouseenter)="showTypeEvidences('LOCATION')" (mouseleave)="hideTypeEvidences('LOCATION')">
                <div class="p-16 fx-row fx-flex-100 align-items-center justify-content-between">
                  <div class="fx-row fx-flex-100 align-items-center justify-content-start">
                    <span class="text light">{{((document && document.trademarks && document.trademarks.length > 0) ?
                      'DOCUMENT.TRADEMARKS_TERRITORIES' : 'DOCUMENT.TERRITORIES') | translate}}</span>
                    <mat-icon class="main ml-5" fontSet="material-icons-outlined" inline inset
                      [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.FILTERED_SECTION' | translate"
                      *ngIf="hasFiltersForSection('territories')">filter_list</mat-icon>
                  </div>

                  <mat-icon [class.shown]="evidenceTypes['LOCATION'] && !document.nonUse" class="visibility-icon"
                    fontSet="material-icons-outlined">{{evidenceTypes['LOCATION'] ? 'visibility' :
                    'visibility_off'}}</mat-icon>
                </div>
                <div class="fx-row align-items-center justify-content-between fx-flex-100 border-left border-box">
                  <app-document-map *ngIf="trademarkTerritoriesLoaded" [territories]='trademarkTerritories'
                    [filter]="documentService.filters.territories" class="fx-flex-100 h-100"></app-document-map>
                </div>
                <div class="fx-flex-100 p-16 fx-column align-items-start justify-content-start border-box">
                  <app-document-countries class="w-100" [shown]="evidenceTypes['LOCATION'] && !document.nonUse"
                    [mode]="'row'" [territories]="trademarkTerritories" [metadata]="metadata"
                    [filter]="documentService.filters.territories" [title]="false"></app-document-countries>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-row fx-wrap align-items-start justify-content-start p-16"
                (mouseenter)="showTypeEvidences('DATE');showTypeEvidences('PERIOD')"
                (mouseleave)="hideTypeEvidences('DATE');hideTypeEvidences('PERIOD')">
                <div class="fx-row align-items-center justify-content-between fx-flex-100">
                  <app-document-timeline [shown]="evidenceTypes['DATE'] && !document.nonUse" [period]='document?.period'
                    class="fx-flex-100" [startFilter]="documentService.filters.period.start"
                    [endFilter]="documentService.filters.period.end"></app-document-timeline>
                </div>
              </div>
              <mat-divider *ngIf="document.users && document.users.length > 0"></mat-divider>
              <div class="fx-row fx-wrap align-items-start justify-content-start p-16"
                (mouseenter)="showTypeEvidences('USER');showTypeEvidences('USER')"
                (mouseleave)="hideTypeEvidences('USER');hideTypeEvidences('USER')"
                *ngIf="document.users && document.users.length > 0">
                <div class="fx-row align-items-center justify-content-between fx-flex-100">
                  <app-document-users [shown]="evidenceTypes['USER']" [users]='document.users || []' class="fx-flex-100"
                    [metadata]="metadata"></app-document-users>
                </div>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label class="text">
                {{'DOCUMENT.INFORMATION_TAB' | translate}}
              </ng-template>
              <div class="fx-row fx-wrap align-items-stretch justify-content-start">
                <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50  border-box p-16">
                  <span class="text light mb-8 fx-flex-100">{{'DOCUMENT.STATUS' | translate}}</span>
                  <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <mat-icon class="mr-5 blue" fontSet="material-icons-outlined"
                      *ngIf="document.status === 'DRAFT'">edit</mat-icon>
                    <mat-icon class="mr-5 light" fontSet="material-icons-outlined"
                      *ngIf="['PENDING','PROCESSING'].includes(document.status)">pending</mat-icon>
                    <mat-icon class="mr-5 green" fontSet="material-icons-outlined"
                      *ngIf="document.status === 'PROCESSED'">check_circle</mat-icon>
                    <mat-icon class="mr-5 red" fontSet="material-icons-outlined"
                      *ngIf="document.status === 'ERROR'">error_outline</mat-icon>
                    <div class="fx-column">
                      <span class="text"
                        [class.light]="['PENDING','PROCESSING'].includes(document.status)">{{'DOCUMENT.STATUS_'+(document.nonUse
                        ? 'NON_USE' : document.status)
                        |
                        translate}}</span>
                      <span class="small light" *ngIf="document.timestamp"
                        [matTooltip]="'DOCUMENT.TIMESTAMP' | translate"
                        [matTooltipClass]="{'uzai-tooltip':true}">{{formatDatetime(document.timestamp)}}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50  border-box  border-left p-16">
                  <span class="text light mb-8 fx-flex-100">{{'DOCUMENT.UPLOAD' | translate}}</span>
                  <div class="fx-row justify-content-start align-items-center fx-flex-100"
                    *ngIf="document.uploader && document.uploader.ref">
                    <app-avatar [user]="document.uploader" [size]="30"></app-avatar>
                    <div class="fx-column ml-10">
                      <span class="text">{{document.uploader.firstName}} {{document.uploader.lastName}}</span>
                      <span class="text light"><a class="text main" (click)="toBatch(document.batch.ref)">Batch
                          n°{{document.batch.number}}</a>
                        -
                        {{formatDate(document.createdAt)}}</span>
                    </div>
                  </div>
                  @if (document.batch && !document.uploader || !document.uploader.ref) {
                  <div class="fx-row justify-content-start align-items-center fx-flex-100">
                    <img src="/assets/icons/icon.svg" class="uzai-avatar" />
                    <div class="fx-column ml-10">
                      <span class="text">UZ.IP <span class="small light">({{'ENTITIES.INTEGRATION' |
                          translate}})</span></span>
                      <span class="text light"><a class="text main" (click)="toBatch(document!.batch.ref)">Batch
                          n°{{document.batch.number}}</a>
                        -
                        {{formatDate(document.createdAt)}}</span>
                    </div>
                  </div>
                  }
                </div>
              </div>
              <mat-divider />
              <!-- document group version -->
              <div class="fx-row fx-wrap align-items-start justify-content-start">
                <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
                  <span class="text light mb-8 fx-flex-100">{{ 'DOCUMENT.UZIP_REF' | translate }}</span>
                  <p>{{ document?._id ?? '-' }}</p>
                </div>
                <div
                  class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box border-left p-16">
                  <span class="text light mb-8 fx-flex-100">{{ 'DOCUMENT.VERSION' | translate }}</span>
                  @if (document?.versionNumber && documentGroup) {
                  <div class="fx-row align-items-center justify-content-start fx-flex-100">
                    <div class="chip fx-row align-items-center justify-content-start clickable"
                      [class.orange]="approval === 'pending'" [class.green]="approval === 'approved'"
                      [class.red]="approval === 'rejected'" [cdkMenuTriggerFor]="versionSelect">
                      <span>{{ 'DOCUMENT.VERSION' | translate }} : {{ document?.versionNumber }}</span>
                      <mat-icon fontSet="material-icons-outlined">arrow_drop_down</mat-icon>
                    </div>
                  </div>
                  <ng-template #versionSelect>
                    <app-document-version-select [currentlySelectedVersionNumber]="document?.versionNumber"
                      [versions]="documentGroup?.versions ?? []"
                      [currentDocumentVersion]="documentGroup?.currentVersion" />
                  </ng-template>
                  } @else {
                  <span class="chip light">{{ 'DOCUMENT.MISSING_VERSION' | translate }}</span>
                  }
                </div>
              </div>
              <mat-divider />
              <div class="fx-row fx-wrap align-items-stretch justify-content-start">
                <app-crawled-document-metadata [id]='document._id'></app-crawled-document-metadata>
              </div>
              <mat-divider />
              <div class="fx-row fx-wrap align-items-start justify-content-start p-16">
                <div class="fx-row align-items-center justify-content-between fx-flex-100">
                  <app-document-tags [id]='document._id' class="fx-flex-100"></app-document-tags>
                </div>
              </div>
              <mat-divider />

              <div class="p-16  fx-row align-items-center justify-content-between">
                <span class="text light">{{'DOCUMENT.NOTES' | translate}}</span>
              </div>
              <mat-divider />
              <div class="fx-column align-items-start justify-content-start ph-16 " *ngIf="document">
                <div class="scrollable" #scrollable>
                  <div *ngFor="let note of document.notes" class="note" (mouseover)="focusedNote = note"
                    (mouseout)="focusedNote = undefined">
                    <div class="fx-row justify-content-between align-items-center  fx-flex-100">
                      <div class="fx-row justify-content-start align-items-center">
                        <app-avatar [user]="note.author" [size]="25"></app-avatar>
                        <div class="fx-column ml-10">
                          <span class="text">{{note.author.firstName}} {{note.author.lastName}}</span>
                          <span class="small light">{{timeAgo(note.timestamp)}}</span>
                        </div>
                      </div>
                      <mat-icon class="red clickable ml-5 delete-note"
                        [style.visibility]="focusedNote && focusedNote._id === note._id ? 'visible' : 'hidden'"
                        fontSet="material-icons-outlined" (click)="deleteNote(note)"
                        *ngIf="canDeleteNote(note)">delete</mat-icon>
                    </div>
                    <mat-card class="p-8 mt-10">
                      <span class="text">{{note.comment}}</span>
                    </mat-card>
                  </div>
                </div>
              </div>
              <div class="add-note-container fx-row align-items-center justify-content-start">
                <app-input placeholder="{{'ACTIONS.ADD_NOTE' | translate}}..." type="text" prefix="edit_note"
                  [(value)]="note" class="fx-flex"></app-input>
                <button class="main-button ml-10" (click)="isNoteDisabled() ? null : addNote()"
                  [class.disabled]="isNoteDisabled()" [disabled]="isNoteDisabled()">
                  {{'ACTIONS.SEND' | translate}}
                </button>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <mat-divider />

      </div>
    </div>
  </mat-card>
</app-document-filters-drawer>
